import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-form-group',
    templateUrl: './form-group.component.html',
    styleUrls: ['./form-group.component.less']
})
export class FormGroupComponent {
    @Input() headerText: string;
    @Input() header: string;

}
